<template>
    <div class="bg-dark" style="min-height:100vh ;">
      <div class="container " style="color:white">
          <div class=""><h3 class="pt-5">{{selectedWord.fullWord}}</h3>
          <span v-for="(sh , index) in selectedWord.heja" :key="index" :style="{background : color[index] }">{{sh}}</span>
          <br>
          <small style="color:gray" v-for="a in selectedWord.ava" :key="a.id">{{a}} / </small><br>
          <small style="color:gray" v-for="h in selectedWord.heja" :key="h.id">{{h}} / </small>
          </div>
          <hr>
          <h3>فیلتر با : </h3>
          <div class="row d-flex justify-content-center"> 
            <div 
            style="min-width:30px;background:whitesmoke;margin:2px;border-radius:10px;text-align:center;color:grey;cursor:pointer" v-for="letter in alphabet" 
            :class="selectedItems.indexOf(letter) !=  -1 ? 'bg-primary text-light' : ''"
            @click="add(letter) "
            :key="letter.index">{{letter}} </div>
          </div>
          <hr>
          <h3>قافیه ها : </h3>
            <div class="row">
            <div class="col-3 mt-4" v-for="(rhym,index) in rhymes.ryhmes" :key="rhym.id">
              <a @click="rhymes.ids[index]" >{{rhym}}</a>
            <br> <span v-for="(h , i) in heja[index]" :key="h.i" :style="start[index] != i + 1 ?  {background:color[i]} :  {background:'transparent'}" > {{h}}</span>
            <br> <small style="color:gray"> / {{rhymes.number[index]}} هجایی</small>
            <br> <small  style="color:gray"> / {{rhymes.ryhmeAva[index].split("-").join(" / ")}} </small>
          </div>
            </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            rhymes:[],
            selectedWord: '',
            heja:[],
            selectedItems:[],
            filterChar: [],
            start : [],
            alphabet :['آ' , 'ب' ,'پ', 'ت' , 'ث' , 'ج' , 'چ' , 'ح' , 'خ' , 'د' , 'ذ' , 'ر' , 'ز' , 'ژ' , 'س' , 'ش' , 'ص' , 'ض' , 'ط' , 'ظ' , 'ع' , 'غ' , 'ف' , 'ق' , 'ک' , 'گ' , 'ل' , 'م' , 'ن' , 'و' , 'ه' , 'ی'] ,
            color:['red' , 'blue' , 'darkgreen' , 'green' , 'orange' , 'pink' , 'darkyellow' , 'purple']
        }
    },
    methods:{
      async add(letter){
        
        if(this.selectedItems[this.selectedItems.indexOf(letter)] == undefined){
        this.selectedItems.push(letter)
        }
        else{
          this.selectedItems.splice(this.selectedItems.indexOf(letter) , 1)
        }
      this.filterChar = this.selectedItems
      let res = await axios.get(`http://185.81.96.220/getRhymes?api_token=${this.$store.getters.token}&id=${this.$route.params.id}&filter=${this.filterChar}`)
        if(res.status == 200){
            this.rhymes = res.data.response
            this.selectedWord = res.data.selectedWord
            this.heja = this.rhymes.heja
            this.start = this.rhymes.start
            console.log(this.start)
        }
      }
    },
    async created(){
        let res = await axios.get(`http://185.81.96.220/getRhymes?api_token=${this.$store.getters.token}&id=${this.$route.params.id}&filter=${this.filterChar}`)
        if(res.status == 200){
            this.rhymes = res.data.response
            this.selectedWord = res.data.selectedWord
            this.heja = this.rhymes.heja
            this.start = this.rhymes.start
            console.log(this.start)
        }
    }
}
</script>